import dayjs from "dayjs";

const shockOption = {
  dataZoom: [
    {
      type: "slider",
      start: 0,
      end: 100,
      show: true,
      showDetail: false,
    },
  ],
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
    formatter: function (params) {
      if (!params || params.length === 0) return '';

      const point = params[0];
      const timestamp = point.axisValue;

      // point.value is an array: [timestamp, magnitude]
      const magnitude = Array.isArray(point.value) ? point.value[1] : point.value;

      // Access the full event payload from the data array [timestamp, magnitude, eventPayload]
      const eventPayload = point.data?.[2];
      const shockData = eventPayload?.deviceAlarm?.shock;

      if (!shockData) {
        // Simple fallback if no detailed data
        return `${dayjs(timestamp).format("MM-DD-YYYY HH:mm:ss")}<br/>Magnitude: ${magnitude} G`;
      }

      // Build comprehensive tooltip with all shock data
      let tooltip = `<div style="padding: 8px;">`;

      // Timestamp (first line)
      tooltip += `<div style="font-weight: bold; font-size: 14px; margin-bottom: 8px; border-bottom: 1px solid #ddd; padding-bottom: 4px;">
        ${dayjs(timestamp).format("MM-DD-YYYY HH:mm:ss")}
      </div>`;

      // Magnitude (second line, prominent)
      tooltip += `<div style="font-size: 13px; margin-bottom: 8px;">
        <strong>Magnitude:</strong> ${magnitude.toFixed(4)} g
      </div>`;

      // Impact Analytics Section
      tooltip += `<div style="margin-top: 8px; margin-bottom: 4px;">
        <strong style="color: #ff6b6b;">IMPACT ANALYTICS</strong>
      </div>`;
      tooltip += `<div style="font-size: 12px; padding-left: 8px;">
        Threshold: ${shockData.shock_thresh} g<br/>
        Duration: ${(shockData.shock_duration * 1000).toFixed(0)} ms<br/>
        State: ${shockData.state === 1 ? 'ACTIVE' : 'INACTIVE'}<br/>
        Alarm Type: ${shockData.alarmType} (Critical Impact)
      </div>`;

      // 3D Axis Breakdown Section
      if (shockData.x !== undefined && shockData.y !== undefined && shockData.z !== undefined) {
        tooltip += `<div style="margin-top: 8px; margin-bottom: 4px;">
          <strong style="color: #4dabf7;">SPATIAL ANALYSIS</strong>
        </div>`;
        tooltip += `<div style="font-size: 12px; padding-left: 8px;">
          X-axis: ${shockData.x.toFixed(4)} g<br/>
          Y-axis: ${shockData.y.toFixed(4)} g<br/>
          Z-axis: ${shockData.z.toFixed(4)} g<br/>
          Dominant: ${shockData.x_axis ? 'X' : shockData.y_axis ? 'Y' : shockData.z_axis ? 'Z' : 'N/A'}
        </div>`;
      }

      // Geographic Context Section
      if (shockData.location) {
        tooltip += `<div style="margin-top: 8px; margin-bottom: 4px;">
          <strong style="color: #51cf66;">GEOGRAPHIC CONTEXT</strong>
        </div>`;
        tooltip += `<div style="font-size: 12px; padding-left: 8px;">
          Latitude: ${shockData.location.latitude.toFixed(6)}°<br/>
          Longitude: ${shockData.location.longitude.toFixed(6)}°<br/>
          Accuracy: ${shockData.location.accuracy}m<br/>
          Type: ${shockData.location.type.toUpperCase()}
        </div>`;
      }

      // System Configuration Section
      tooltip += `<div style="margin-top: 8px; margin-bottom: 4px;">
        <strong style="color: #ffd43b;">SYSTEM CONFIG</strong>
      </div>`;
      tooltip += `<div style="font-size: 12px; padding-left: 8px;">
        Holdoff: ${shockData.holdoff} sec<br/>
        SetOnlyOnce: ${shockData.setOnlyOnce === 1 ? 'Enabled' : 'Disabled'}<br/>
        Location Required: ${shockData.locationRequired === 1 ? 'Yes' : 'No'}
      </div>`;

      tooltip += `</div>`;

      return tooltip;
    },
  },
  grid: {
    left: 60,
    top: 20,
    right: 20,
    bottom: 100,
  },
  xAxis: [
    {
      type: "category",
      name: "Time",
      boundaryGap: true,
      nameGap: 40,
      nameLocation: "middle",
      axisPointer: {
        label: {
          formatter: function (params) {
            return dayjs(params.value).format("MM-DD-YYYY HH:mm:ss");
          },
        },
        handle: {
          show: false,
        },
      },
      axisLabel: {
        hideOverlap: true,
        formatter: function (value) {
          const date = new Date(value);
          const formattedDate = `${(date.getMonth() + 1)
            .toString()
            .padStart(2, "0")}/${date
            .getDate()
            .toString()
            .padStart(2, "0")}/${date.getFullYear()}`;
          return formattedDate;
        },
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      name: "Magnitude (G)",
      nameGap: 40,
      nameRotate: 90,
      nameLocation: "middle",
    },
  ],
  series: [
    {
      name: "Shock Magnitude",
      data: [],
      type: "bar",
      itemStyle: {
        color: '#FF6B6B', // Red color to indicate alarm/warning
      },
    },
  ],
};

export default shockOption;
